'use client';

import { useEffect, useRef } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@/providers/userContext';
import { consumePostLoginRedirect } from '@/lib/client/postLoginRedirect';
import { reconcilePendingVisits } from '@/lib/client/pendingVisits';
import { reconcileGuestSaved } from '@/lib/client/guestSavedSync';
export default function CheckAuth() {
  const {
    setUser,
    setAuthChecked
  } = useAuth();
  const router = useRouter();
  const hasRunRef = useRef(false);
  useEffect(() => {
    if (hasRunRef.current) return;
    hasRunRef.current = true;
    let cancelled = false;
    async function loadUser() {
      try {
        const res = await fetch('/api/me', {
          cache: 'no-store'
        });
        if (!res.ok) {
          if (!cancelled) {
            setUser(null);
            setAuthChecked(true);
          }
          return;
        }
        const data = await res.json();
        if (!cancelled) {
          const user = data?.user ?? null;
          setUser(user);
          if (user) {
            // Sync guest data after login
            reconcilePendingVisits().catch(() => {});
            reconcileGuestSaved().catch(() => {});
            const target = consumePostLoginRedirect();
            if (target) router.replace(target);
          }
          setAuthChecked(true);
        }
      } catch {
        if (!cancelled) {
          setUser(null);
          setAuthChecked(true);
        }
      }
    }
    loadUser();
    return () => {
      cancelled = true;
    };
  }, [setUser, setAuthChecked, router]);
  return null;
}